var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.hasAccessToImpactView
        ? _c("hierarchy", {
            attrs: { units: _vm.unitsForDisplay, "is-unit-manager-view": "" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }